import './Servicios.css';

const Servicios = () => {
  return (
    <section id="servicios" className="servicios-container">
      {/* HERO: Nuestros servicios */}
      <div className="servicios-hero">
        <h1 className="servicios-titulo">Nuestros servicios</h1>
        <p className="servicios-intro">
          Acompañamos a tu organización en todo el proceso: desde la formación del personal
          hasta la documentación y la implementación de soluciones técnicas.
        </p>

        <div className="servicios-grid">
          <div className="servicio-card">
            <h3>Cursos y Programas de Capacitación Técnica</h3>
            <p>
              Cursos generales, software técnico, automatización, energía, seguridad,
              inteligencia artificial y más.
            </p>
            <a href="#servicios-cursos" className="btn-servicio">
              Ver más
            </a>
          </div>

          <div className="servicio-card">
            <h3>Desarrollo de Materiales Profesionales</h3>
            <p>
              Manuales, guías, presentaciones ejecutivas, catálogos y documentación
              institucional a la medida.
            </p>
            <a href="#servicios-materiales" className="btn-servicio">
              Ver más
            </a>
          </div>

          <div className="servicio-card">
            <h3>Consultorías Especializadas</h3>
            <p>
              Proyectos de diagnóstico, mejora, automatización, energía e innovación
              tecnológica con enfoque práctico y normativo.
            </p>
            <a href="#servicios-consultorias" className="btn-servicio">
              Ver más
            </a>
          </div>
        </div>
      </div>

      {/* DETALLE: Cursos */}
      <div id="servicios-cursos" className="servicios-detalle">
        <h2 className="detalle-titulo">Cursos y Programas de Capacitación Técnica</h2>
        <p className="detalle-intro">
          Ofrecemos una amplia gama de cursos diseñados para fortalecer competencias técnicas
          y de gestión en diferentes niveles. Todos pueden impartirse de forma presencial
          o en línea.
        </p>

        <div className="categorias-grid">
          <div className="categoria-card">
            <h3>1. Cursos Generales</h3>
            <ul>
              <li>Informática y Diseño — 48 hrs</li>
              <li>Gestión de Proyectos — 36 hrs</li>
              <li>Calidad — 36 hrs</li>
              <li>Algoritmos y Programación — 36 hrs</li>
              <li>Contabilidad y Costos — 24 hrs</li>
            </ul>
          </div>

          <div className="categoria-card">
            <h3>2. Cursos Especializados</h3>
            <ul>
              <li>Higiene y Seguridad Industrial — 24 hrs</li>
              <li>Mantenimiento — 24 hrs</li>
              <li>Metrología y Normalización — 36 hrs</li>
              <li>Sistemas e Instalaciones Hidráulicas — 24 hrs</li>
              <li>Métodos Numéricos — 24 hrs</li>
            </ul>
          </div>

          <div className="categoria-card">
            <h3>3. Seguridad y Cumplimiento</h3>
            <ul>
              <li>Seguridad en Riesgos Eléctricos — 8 hrs</li>
              <li>Seguridad en Trabajos en Altura — 8 hrs</li>
              <li>Seguridad en Espacios Confinados — 8 hrs</li>
              <li>Seguridad Industrial Integral — 24 hrs</li>
            </ul>
          </div>

          <div className="categoria-card">
            <h3>4. Cursos Técnicos y de Software</h3>
            <ul>
              <li>Dibujo Mecánico — 48 hrs</li>
              <li>AutoCAD — 36 hrs</li>
              <li>SolidWorks — 48 hrs</li>
              <li>CATIA (Modelado y Simulación 3D) — 36 hrs</li>
              <li>MATLAB — 12 hrs</li>
            </ul>
          </div>

          <div className="categoria-card">
            <h3>5. Automatización y Control</h3>
            <ul>
              <li>PLC (Controladores Lógicos Programables) — 16 hrs</li>
              <li>Instrumentación y Control — 16 hrs</li>
              <li>Neumática e Hidráulica — 12 hrs</li>
              <li>Electricidad Residencial y Comercial — 24 hrs</li>
              <li>Control de Máquinas Eléctricas — 16 hrs</li>
            </ul>
          </div>

          <div className="categoria-card">
            <h3>6. Energía y HVAC</h3>
            <ul>
              <li>Sistemas de Generación de Energía — 30 hrs</li>
              <li>Refrigeración y Aire Acondicionado — 24 hrs</li>
            </ul>
          </div>

          <div className="categoria-card">
            <h3>7. Formación y Diplomados</h3>
            <ul>
              <li>Formación de Instructores — 25 hrs</li>
              <li>Diplomado en Normativa Ferroviaria — 40 hrs</li>
              <li>Impresión 3D — 24 hrs</li>
            </ul>
          </div>

          <div className="categoria-card">
            <h3>8. Inteligencia Artificial</h3>
            <ul>
              <li>IA Industrial — 30 hrs</li>
              <li>IA Comercial — 24 hrs</li>
            </ul>
            <p className="nota-categoria">
              También diseñamos cursos específicos de IA industrial y comercial según tus procesos
              y objetivos.
            </p>
          </div>

          <div className="categoria-card">
            <h3>Otros cursos a la medida</h3>
            <p>
              ¿Buscas un curso específico? Diseñamos contenidos a la medida según tu sector,
              tus equipos y tus objetivos de capacitación.
            </p>
          </div>
        </div>

        <p className="nota-dc3">
          Todos nuestros cursos incluyen constancia de habilidades DC-3 avalada por la
          Secretaría del Trabajo y Previsión Social, conforme a la normatividad vigente.
        </p>
      </div>

      {/* DETALLE: Desarrollo de materiales */}
      <div id="servicios-materiales" className="servicios-detalle">
        <h2 className="detalle-titulo">Desarrollo de Materiales Profesionales</h2>
        <p className="detalle-intro">
          En STEM Instituto México diseñamos y elaboramos materiales personalizados para
          empresas, instituciones, proyectos educativos y capacitación industrial. Todos
          nuestros materiales se desarrollan con estándares profesionales, diseño claro
          y enfoque en resultados.
        </p>

        <div className="categorias-grid">
          <div className="categoria-card">
            <h3>1. Manual Técnico o Instructivo</h3>
            <p>
              Procedimientos, operación, mantenimiento, seguridad, SCADA y procesos
              industriales redactados de forma clara y utilizable en campo.
            </p>
          </div>

          <div className="categoria-card">
            <h3>2. Guía Didáctica o Cuaderno de Trabajo</h3>
            <p>
              Actividades, ejercicios, evaluaciones y contenidos pedagógicos listos para
              cursos, talleres y programas internos.
            </p>
          </div>

          <div className="categoria-card">
            <h3>3. Presentación Ejecutiva o Académica</h3>
            <p>
              Informes, propuestas, clases magistrales y pitch institucional con diseño
              profesional y enfoque en el mensaje clave.
            </p>
          </div>

          <div className="categoria-card">
            <h3>4. Catálogo de Servicios o Productos</h3>
            <p>
              Formato empresarial, técnico, comercial o institucional para mostrar tu
              oferta de forma clara y atractiva.
            </p>
          </div>

          <div className="categoria-card">
            <h3>5. Diseño de Curso o Contenido Formativo</h3>
            <p>
              Temarios, estructuras modulares, actividades y evaluaciones para programas
              internos o externos de capacitación.
            </p>
          </div>

          <div className="categoria-card">
            <h3>6. Documentación Institucional Personalizada</h3>
            <p>
              Políticas, procedimientos, formatos, fichas técnicas y documentos de
              cumplimiento adaptados a tu realidad operativa.
            </p>
          </div>
        </div>
      </div>

      {/* DETALLE: Consultorías especializadas */}
      <div id="servicios-consultorias" className="servicios-detalle">
        <h2 className="detalle-titulo">Consultorías Especializadas</h2>
        <p className="detalle-intro">
          En STEM Instituto México ofrecemos consultoría técnica, estratégica y normativa
          para empresas, instituciones y proyectos industriales. Acompañamos a nuestros
          clientes con soluciones prácticas, personalizadas y de alta especialización.
        </p>

        <div className="categorias-grid">
          <div className="categoria-card">
            <h3>1. Modelado y Diseño Mecánico</h3>
            <p>
              SolidWorks, AutoCAD, CATIA, planos, ensambles y manufactura para desarrollo
              y optimización de productos.
            </p>
          </div>

          <div className="categoria-card">
            <h3>2. Automatización y Control Industrial</h3>
            <p>
              PLC, instrumentación, SCADA y sistemas de control de procesos para aumentar
              la eficiencia y confiabilidad.
            </p>
          </div>

          <div className="categoria-card">
            <h3>3. Normatividad y Legislación Industrial</h3>
            <p>
              ASTM, ISO, NOM, STPS y legislación técnica aplicada a tu sector para asegurar
              cumplimiento y operación segura.
            </p>
          </div>

          <div className="categoria-card">
            <h3>4. Asesoría en Hidrocarburos y Sistemas de Gestión (SASISOPA)</h3>
            <p>
              Implementación, auditorías internas, procedimientos y evidencias para
              cumplimiento regulatorio.
            </p>
          </div>

          <div className="categoria-card">
            <h3>5. Energía y Eficiencia Energética</h3>
            <p>
              Sistemas eléctricos, energía industrial y eficiencia en plantas para reducir
              consumo y mejorar desempeño.
            </p>
          </div>

          <div className="categoria-card">
            <h3>6. Procesos Industriales y Optimización</h3>
            <p>
              Flujos de trabajo, mantenimiento, mejora continua y calidad orientada
              a resultados.
            </p>
          </div>

          <div className="categoria-card">
            <h3>7. Inteligencia Artificial Aplicada a la Industria</h3>
            <p>
              Automatización con IA, predicción, análisis e integración de soluciones de
              inteligencia artificial en procesos industriales.
            </p>
          </div>

          <div className="categoria-card">
            <h3>8. Capacitación Técnica Empresarial a la Medida</h3>
            <p>
              Diagnóstico, diseño de programas y formación especializada según el perfil
              de tu organización.
            </p>
          </div>

          <div className="categoria-card">
            <h3>9. Documentación Técnica y Operativa</h3>
            <p>
              Procedimientos, instructivos, hojas técnicas y políticas internas alineadas
              a tu operación real.
            </p>
          </div>

          <div className="categoria-card">
            <h3>10. Otros tipos de consultoría</h3>
            <p>
              Cuéntanos brevemente tu necesidad y diseñamos una propuesta específica
              para tu proyecto.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Servicios;
